import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSWR from "swr";
import { API_NOTIFICATION_UNREAD_NOTIFICATIONS_COUNT } from "constants/ApiConstant";

const POLL_INTERVAL_MS = 60000;

export default function useNotificationsSidebar() {
  const location = useLocation();
  const getUnreadCount = useSWR({
    url: API_NOTIFICATION_UNREAD_NOTIFICATIONS_COUNT,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      getUnreadCount.mutate();
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [getUnreadCount]);

  const unreadCount = getUnreadCount?.data?.data?.unreadCount ?? 0;
  // const unreadCount = 0;
  const isOnNotificationsPage = location.pathname.includes("notifications");
  const showBadge = unreadCount > 0 && !isOnNotificationsPage;

  return {
    unreadCount,
    showBadge,
    getUnreadCount,
  };
}
